import * as React from 'react'
import { GlobalProps } from 'types'
import { StoreLocator as ReactiveStoreLocator, DeveloperToolkit as ReactiveStoreLocatorDeveloperToolkit, clusterPinBuilder, useStorelocatorAutocomplete } from '@dotdev/reactive-storelocator'
import * as Layouts from 'layouts'
import * as Sections from 'sections'
import * as Snippets from 'snippets'

export const StoresPageTemplate: React.FC<StoresPageTemplate.Props> = (props) => {
  React.useEffect(() => {
    const getConfig = async () => {
      (function(s,t,o,c,k){c=s.createElement(t);c.src=o;c.async=1
        k=s.getElementsByTagName(t)[0];k.parentNode.insertBefore(c,k)
      })(document,'script','//stockist.co/embed/v1/widget.min.js')
    }
    getConfig()
  }, [])

  return (
    <Layouts.Theme {...props}>
      <main className={'max-w-container mx-auto flex flex-wrap px-1-6 md:px-0 pb-4 md:pb-0'}>
        <Snippets.Heading
          size={'h1'}
          tag={'h1'}
          className={'w-full text-center md:leading-tight mt-3-2 mb-3-2 md:mt-3-9 md:mb-4-8'}
        >
          Find a store or stockist
        </Snippets.Heading>
        <div data-stockist-widget-tag={props.data.shop.name === 'Helen Kaminski US' ? 'u16072' : 'u16055'} className="mx-auto">Loading store locator
        from <a href="https://stockist.co">Stockist store locator</a>...</div>
      </main>
    </Layouts.Theme>
  )
}

export namespace StoresPageTemplate {
  export interface Props extends GlobalProps { }
}
